module.exports = __webpack_public_path__ + "static/media/adv_img_6.5e0aca0f.jpg";